


























import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import {Prop, Watch} from 'vue-property-decorator';
import {EMAIL_VALIDATOR_INSTANCE} from '@/utils/email-validator';

@Component({
  components: {},
  mixins: [BindAttrs]
})
export default class AmetrasEmailListFieldTemplate extends Vue {
  @Prop() value!: string[];
  internalValue: string[] = [];
  validation: boolean = true;
  testedMailAddresses: { [key: string]: boolean | undefined } = {};
  rules = [(currentValues: string[]) => {
    for (const currentValue of currentValues) {
      const mailIdxValue = this.testedMailAddresses[currentValue];
      if (mailIdxValue === undefined) {
        this.testedMailAddresses[currentValue] = EMAIL_VALIDATOR_INSTANCE.validate(currentValue);
      }
    }
    for (const currentValue of currentValues) {
      const mailIdxValue = this.testedMailAddresses[currentValue];
      if (mailIdxValue === false) {
        return currentValue + ' ist keine valide E-Mail';
      }
    }
    return true;
  }];
  @Watch('value') modelChanges(newValue: string[]) {
    if (newValue !== this.internalValue) {
      this.internalValue = newValue;
    }
  }
  created() {
    this.internalValue = this.value;
  }
  remove(item: string) {
    this.internalValue.splice(this.internalValue.indexOf(item), 1);
    this.emitChange();
  }
  onChange(data: string[]) {
    this.internalValue = data;
    this.emitChange();
  }
  emitChange() {
    this.$emit('input', this.internalValue);
    this.$emit('change', this.internalValue);
  }
}
